import React from 'react'
import cn from 'classnames'
import styles from './CellText.module.scss'

interface Props {
  ellipsis?: boolean
  minWidth?: number|string
  maxWidth?: number|string
  children: string
}

export const TableCellText = ({ ellipsis, minWidth, maxWidth, children }: Props) => {
  const style = React.useMemo((): React.CSSProperties => ({
    minWidth,
    maxWidth,
  }), [minWidth, maxWidth])

  return (
    <div style={style} className={cn(styles.root, ellipsis && styles.ellipsis)} title={children}>
      {children}
    </div>
  )
}
